import axios from "axios";
import { emitGlobalError } from "../hooks/globalError";
import { API_URL } from "./constants";

const appClient = axios.create({
  baseURL: API_URL,
  timeout: 15000,
  withCredentials: true, // 쿠키 인증이면 true 유지
});

appClient.interceptors.response.use(
  (res) => res,
  (error) => {
    const isNetworkError = !error.response; // 서버 연결 자체가 안 됨(ECONNREFUSED/timeout/CORS 등)
    const status = error.response?.status;

    // "서버 문제" 기준: 네트워크 장애 OR 5xx
    if (isNetworkError || (status >= 500 && status <= 599)) {
      emitGlobalError({
        title: "로그인 진입에 실패하였습니다.",
        message: isNetworkError
          ? "네트워크 상태를 확인하거나 잠시 후 다시 시도해주세요."
          : "잠시 후 다시 시도해주세요.",
        status: status ?? 0
      });
    }

    return Promise.reject(error);
  }
);

export default appClient;
